var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "client-staff" },
    [
      _c(
        "div",
        { staticClass: "client-search" },
        [
          _c("el-input", {
            staticClass: "base-msg-input",
            attrs: {
              size: "mini",
              "suffix-icon": "el-icon-search",
              placeholder: "客户姓名(昵称)",
              clearable: ""
            },
            on: { blur: _vm.onInputBlur, clear: _vm.onInputBlur },
            model: {
              value: _vm.params.customerName,
              callback: function($$v) {
                _vm.$set(_vm.params, "customerName", $$v)
              },
              expression: "params.customerName"
            }
          }),
          _c("el-button", { attrs: { size: "mini" } }, [
            _vm._v("最后访问时间")
          ]),
          _c("el-date-picker", {
            staticStyle: { width: "240px", "margin-right": "10px" },
            attrs: {
              size: "mini",
              type: "datetimerange",
              "value-format": "yyyy-MM-dd HH:mm:ss",
              "range-separator": "~",
              editable: false,
              "start-placeholder": "开始时间",
              "end-placeholder": "结束时间",
              clearable: "",
              "default-time": ["00:00:00", "23:59:59"]
            },
            on: { change: _vm.selectTime },
            model: {
              value: _vm.dateTime,
              callback: function($$v) {
                _vm.dateTime = $$v
              },
              expression: "dateTime"
            }
          }),
          _c("el-input", {
            staticClass: "base-msg-input",
            attrs: {
              size: "mini",
              "suffix-icon": "el-icon-search",
              placeholder: "手机号码",
              clearable: ""
            },
            on: { blur: _vm.onInputBlur, clear: _vm.onInputBlur },
            model: {
              value: _vm.params.phoneNumber,
              callback: function($$v) {
                _vm.$set(_vm.params, "phoneNumber", $$v)
              },
              expression: "params.phoneNumber"
            }
          }),
          _c("el-input", {
            staticClass: "base-msg-input",
            attrs: {
              size: "mini",
              "suffix-icon": "el-icon-search",
              placeholder: "跟进人",
              clearable: ""
            },
            on: { blur: _vm.onInputBlur, clear: _vm.onInputBlur },
            model: {
              value: _vm.params.follower,
              callback: function($$v) {
                _vm.$set(_vm.params, "follower", $$v)
              },
              expression: "params.follower"
            }
          }),
          _c("el-button", { attrs: { size: "mini" } }, [_vm._v("交互行为")]),
          _c(
            "el-select",
            {
              attrs: { placeholder: "请选择", size: "mini", clearable: "" },
              on: { change: _vm.getPollList, clear: _vm.getPollList },
              model: {
                value: _vm.params.interactionBehavior,
                callback: function($$v) {
                  _vm.$set(_vm.params, "interactionBehavior", $$v)
                },
                expression: "params.interactionBehavior"
              }
            },
            _vm._l(_vm.options1, function(item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.label, value: item.label }
              })
            }),
            1
          ),
          _c(
            "el-checkbox",
            {
              staticStyle: { margin: "0 30px" },
              on: { change: _vm.getPollList },
              model: {
                value: _vm.value,
                callback: function($$v) {
                  _vm.value = $$v
                },
                expression: "value"
              }
            },
            [_vm._v("只看无人跟进线索")]
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "right" } },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.handleVisible2 }
                },
                [_vm._v("跟进分配")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            [
              _c(
                "el-table",
                {
                  ref: "cusChatTable",
                  staticStyle: { "font-size": "13px" },
                  attrs: {
                    size: "small",
                    data: _vm.tableData,
                    fit: "",
                    "highlight-current-row": "",
                    align: "center",
                    "header-cell-style": { background: "#F9F9F9" },
                    height: "calc(100vh - 235px)"
                  },
                  on: { "selection-change": _vm.handleSelectionChange }
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "55" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "customerName",
                      label: "客户",
                      "min-width": "120"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      {
                                        staticStyle: { padding: "0" },
                                        attrs: { span: 30 }
                                      },
                                      [
                                        _c("el-avatar", {
                                          attrs: {
                                            size: "medium",
                                            shape: "square",
                                            src: scope.row.avatar
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c("el-col", { attrs: { span: 70 } }, [
                                      scope.row.customerName != null
                                        ? _c("div", [
                                            _vm._v(
                                              " " +
                                                _vm._s(scope.row.customerName) +
                                                " "
                                            )
                                          ])
                                        : _c("div", [_vm._v("--")]),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            color: "#a09f9fc9",
                                            "font-size": "12px"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(scope.row.customerName) +
                                              " "
                                          ),
                                          scope.row.type == 1
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    color: "rgb(70, 189, 10)"
                                                  }
                                                },
                                                [_vm._v(" @微信")]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    color: "rgb(8, 168, 231)"
                                                  }
                                                },
                                                [_vm._v(" @企业微信")]
                                              )
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "userName", label: "性别" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(scope.row.gender == "M" ? "男" : "女") +
                                " "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "phoneNumber", label: "手机号" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "introducer", label: "介绍人" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "consultant", label: "所属顾问" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "follower", label: "跟进人" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "transactionStatus", label: "成交状态" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "visitCount", label: "访问次数" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "visitTime",
                      label: "最后访问时间",
                      "min-width": "120"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "usageScenario", label: "交互行为" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "div",
                              _vm._l(scope.row.tagIdList, function(item) {
                                return _c(
                                  "el-tag",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.tagName != null,
                                        expression: "item.tagName != null"
                                      }
                                    ],
                                    key: item.tagId,
                                    staticStyle: { margin: "5px 4px 0 0" },
                                    attrs: { size: "small" }
                                  },
                                  [_vm._v(" " + _vm._s(item.tagName) + " ")]
                                )
                              }),
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "recentTime", label: "详情" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#409eff",
                                  cursor: "pointer"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.getCustomerDetail(scope.row)
                                  }
                                }
                              },
                              [_vm._v("查看")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("Pagination", {
        attrs: { childMsg: _vm.pageparm, pageSizes: _vm.pageSizes },
        on: { callBack: _vm.callBack }
      }),
      _c("StaffTree", {
        ref: "tree",
        attrs: {
          title: "添加成员",
          dialogVisibleTree: _vm.dialogVisibleTree,
          currentSelectMember: _vm.currentSelectMember
        },
        on: { closeTree: _vm.closeTree, clickSubmitTree: _vm.clickSubmitTree }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "客户详情",
            visible: _vm.dialogVisible1,
            width: "35%"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible1 = $event
            },
            close: function($event) {
              _vm.dialogVisible1 = false
            }
          }
        },
        [
          _c("div", { staticClass: "dialog" }, [
            _c("div", { staticClass: "list" }, [
              _c("div", { staticClass: "left" }, [
                _c(
                  "div",
                  { staticClass: "avatar" },
                  [
                    _c("el-image", {
                      staticStyle: {
                        width: "40px",
                        height: "40px",
                        "border-radius": "4px"
                      },
                      attrs: {
                        src: _vm.customerInfo.avatar
                          ? _vm.customerInfo.avatar
                          : "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
                      }
                    })
                  ],
                  1
                ),
                _c("div", { staticStyle: { "margin-left": "10px" } }, [
                  _c("div", { staticStyle: { "margin-bottom": "4px" } }, [
                    _vm._v(
                      " 姓名：" +
                        _vm._s(_vm.customerInfo.customerName || "--") +
                        " "
                    )
                  ]),
                  _c("div", [_vm._v("昵称：昵称")])
                ])
              ]),
              _c("div", { staticClass: "item" }, [
                _vm._v(
                  " 性别：" +
                    _vm._s(_vm.customerInfo.gender == "M" ? "男" : "女") +
                    " "
                )
              ]),
              _c("div", { staticClass: "item" }, [
                _vm._v(
                  "手机号：" + _vm._s(_vm.customerInfo.phoneNumber || "--")
                )
              ]),
              _c("div", { staticClass: "item" }, [
                _vm._v("介绍人：" + _vm._s(_vm.customerInfo.introducer || "--"))
              ]),
              _c("div", { staticClass: "item" }, [
                _vm._v(
                  " 所属顾问：" +
                    _vm._s(_vm.customerInfo.consultant || "--") +
                    " "
                )
              ]),
              _c("div", { staticClass: "item" }, [
                _vm._v(
                  " 成交状态： " +
                    _vm._s(_vm.customerInfo.transactionStatus) +
                    " "
                )
              ])
            ]),
            _c(
              "div",
              { staticClass: "list" },
              [
                _c("div", { staticStyle: { "font-weight": "bold" } }, [
                  _vm._v("浏览记录：")
                ]),
                _c(
                  "el-scrollbar",
                  { staticStyle: { height: "150px" } },
                  [
                    _vm.customerInfo.wxUserProductRecord &&
                    _vm.customerInfo.wxUserProductRecord.length == 0
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "padding-top": "60px",
                              "text-align": "center"
                            }
                          },
                          [_vm._v(" 暂无记录 ")]
                        )
                      : _vm._l(_vm.customerInfo.wxUserProductRecord, function(
                          i
                        ) {
                          return [
                            _c("div", { staticClass: "item" }, [
                              _vm._v(" " + _vm._s(_vm.handleDate(i.pbasTime))),
                              _c("span", [_vm._v(_vm._s(i.pbasSname))])
                            ])
                          ]
                        })
                  ],
                  2
                ),
                _c(
                  "div",
                  {
                    staticStyle: { "margin-top": "15px", "font-weight": "bold" }
                  },
                  [_vm._v("跟进记录：")]
                ),
                _c(
                  "el-scrollbar",
                  { staticStyle: { height: "150px" } },
                  [
                    !_vm.customerInfo.leadsRecordFollow
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "padding-top": "60px",
                              "text-align": "center"
                            }
                          },
                          [_vm._v(" 暂无记录 ")]
                        )
                      : _vm._l(_vm.customerInfo.leadsRecordFollow, function(y) {
                          return [
                            _c("div", { staticClass: "item" }, [
                              _vm._v(" " + _vm._s(_vm.handleDate(y.visitTime))),
                              _c("span", [_vm._v(_vm._s(y.follower || "--"))])
                            ]),
                            _c("div", [
                              _vm._v("备注：" + _vm._s(y.remark || "--"))
                            ])
                          ]
                        })
                  ],
                  2
                )
              ],
              1
            )
          ])
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "跟进分配",
            visible: _vm.dialogVisible2,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible2 = $event
            },
            close: function($event) {
              _vm.dialogVisible2 = false
            }
          }
        },
        [
          _c("div", [
            _c(
              "div",
              [
                _vm._v(" 请选择跟进人： "),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "info" },
                    on: {
                      click: function($event) {
                        return _vm.clickAddMember(2)
                      }
                    }
                  },
                  [_vm._v("通过组织架构选择")]
                )
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { margin: "15px 0" } },
              [
                _vm._v(" 已选择： "),
                _vm._l(_vm.searchMenNames, function(tag) {
                  return _c(
                    "el-tag",
                    {
                      key: tag.id,
                      staticStyle: { margin: "5px" },
                      attrs: { closable: "", size: "mini" },
                      on: {
                        close: function($event) {
                          return _vm.removeTag(tag)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(tag.name) + " ")]
                  )
                })
              ],
              2
            )
          ]),
          _c(
            "div",
            { staticStyle: { "text-align": "right" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.addfollowers }
                },
                [_vm._v("确认")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }